import { HttpRequest, HttpMethod } from "./http";

class AppCatalogCouponTemplateProvider extends HttpRequest {
    list(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/catalog/coupon-templates", params);
    }

    get(id) {
        return this.request(HttpMethod.Get, `/api/v1/bo/catalog/coupon-templates/${id}`);
    }

    create(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/catalog/coupon-templates", payload);
    }

    update(id, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/catalog/coupon-templates/${id}`, payload);
    }

    remove(id) {
        return this.request(HttpMethod.Delete, `/api/v1/bo/catalog/coupon-templates/${id}`);
    }
}

export default AppCatalogCouponTemplateProvider;
